import {
  StatsigClient,
  type StatsigOptions,
  type StatsigUser,
} from '@statsig/react-bindings'

import { setupStatsigForReactNative } from './rnSetup'
import { getStatsigMetadataAdditions } from './statsigMetadata'

// Vendored from @statsig/react-native-bindings' StatsigClientRN. A StatsigClient
// pre-configured for React Native: AsyncStorage persistence, AppState-driven
// visibility, and (device-info-free) metadata additions.
export class StatsigClientRN extends StatsigClient {
  readonly __isRnClient = true

  constructor(
    sdkKey: string,
    user: StatsigUser,
    options: StatsigOptions | null = null,
  ) {
    const opts = options ?? {}
    setupStatsigForReactNative(getStatsigMetadataAdditions(), opts)

    super(sdkKey, user, opts)
  }
}
